<template>
  <div>
    <v-container grid-list-xl fluid class="px-8 py-4">
      <div class="mb-3">
        <h1 class="fs-18 lh-18 text-uppercase mt-1 font-weight-700">
          APPROVAL MAPPING
        </h1>
        <v-breadcrumbs class="px-0 py-2" :items="breadcrumbs"></v-breadcrumbs>
      </div>
      <v-row no-gutters align="center" justify="space-between" class="mb-3">
        <v-col cols="12" sm="6">
          <h1 class="fs-20 font-weight-bold bluedarken--text">
            Approval Mapping - {{ item.district ? item.district.name : '' }}
          </h1>
        </v-col>
      </v-row>
      <div v-if="loading" class="text-center py-12">
        <v-progress-circular size="50" color="primary" indeterminate />
      </div>
      <v-card v-else :loading="loading" class="elevation-card rounded-10">
        <ValidationObserver ref="obs">
          <v-form @submit.prevent="save" class="pa-0">
            <v-card-text class="pb-0">
              <v-row
                v-for="(approver, index) in item.listApproval"
                :key="index"
                class="px-3 border-b-1 mb-3"
              >
                <v-col cols="2" class="align-self-center">
                  <span class="fs-16 lightblack--text font-weight-500">
                    Approver {{ index + 1 }}
                  </span>
                </v-col>
                <!-- <v-col cols="12" class="pt-2 py-0 px-0">
                  <v-row class="px-6">
                    <span class="fs-16 lightblack--text font-weight-500">Approver {{ index + 1 }}</span>
                    <v-spacer />
                    <v-btn
                      small
                      color="green"
                      class="mt-1 white--text mr-3"
                      @click="addApprover(index)"
                    >
                      <v-icon>add</v-icon>
                    </v-btn>
                    <v-btn
                      v-if="index > 0"
                      small
                      color="red"
                      class="mt-1 white--text"
                    >
                      <v-icon>delete_outline</v-icon>
                    </v-btn>
                  </v-row>
                </v-col> -->
                <v-col cols="6" class="py-0 pt-2">
                  <ValidationProvider
                    name="Group"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <label
                      class="mb-1 d-block fs-12 font-weight-regular"
                      :for="'group' + index"
                    >
                      Group
                    </label>
                    <v-autocomplete
                      :id="'group' + index"
                      single-line
                      outlined
                      dense
                      :items="groups"
                      placeholder="Select Group"
                      v-model="approver.group_id"
                      @change="getUsers(approver, 'changed')"
                      item-text="name"
                      item-value="id"
                      class="mb-3 mt-3"
                      required
                      hide-details
                      :error-messages="errors"
                    />
                  </ValidationProvider>
                  <ValidationProvider
                    name="Select User"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <label
                      class="mb-1 fs-12 font-weight-regular"
                      :for="'user' + index"
                    >
                      User
                    </label>
                    <img
                      v-if="approver.loadingUsers"
                      src="@/assets/images/loading-bar.gif"
                      class="pl-1"
                      style="height: 22px;position: absolute;"
                      alt="loader"
                    />
                    <v-autocomplete
                      :id="'user' + index"
                      single-line
                      outlined
                      dense
                      :items="approver.users"
                      placeholder="Select User"
                      v-model="approver.user_ids"
                      item-text="user.name"
                      item-value="user_id"
                      required
                      hide-details
                      multiple
                      :disabled="approver.users.length < 1"
                      :filled="approver.users.length < 1"
                      :error-messages="errors"
                      class="mb-8"
                    />
                  </ValidationProvider>
                </v-col>
                <v-col cols="auto" class="align-self-center">
                  <v-btn
                    small
                    color="green"
                    class="mt-1 white--text mr-3"
                    @click="addApprover(index)"
                  >
                    <v-icon>add</v-icon>
                  </v-btn>
                  <v-btn
                    v-if="index > 0"
                    @click="removeApprover(index)"
                    small
                    color="red"
                    class="mt-1 white--text"
                  >
                    <v-icon>delete_outline</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions class="pb-6 px-6">
              <v-spacer></v-spacer>
              <v-btn
                color="#bd1e19"
                dark
                to="/sshcp/approval/mapping"
                class="btn-medium px-4"
              >
                Cancel
              </v-btn>
              <v-btn color="primary" class="btn-medium px-4" dark type="submit">
                {{ isEdit ? 'Save' : 'Submit' }}
              </v-btn>
            </v-card-actions>
          </v-form>
        </ValidationObserver>
      </v-card>
    </v-container>
    <progress-dialog :show="progressDialogLoading" text="Please wait">
    </progress-dialog>
  </div>
</template>

<script>
import ProgressDialog from '@/components/progress_dialog';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import ACLMixin from '@/mixins/ACLMixin';

export default {
  components: { 'progress-dialog': ProgressDialog },
  props: ['id'],
  mixins: [ACLMixin],
  data() {
    return {
      progressDialogLoading: false,
      loading: true,
      breadcrumbs: [
        {
          text: 'Approval Management',
          disabled: true,
          href: 'breadcrumbs_dashboard'
        },
        {
          text: 'User Mapping List',
          disabled: true,
          href: 'breadcrumbs_link_1'
        },
        {
          text: 'Add New User Mapping',
          disabled: true,
          href: 'breadcrumbs_link_1'
        }
      ],
      timeout: null,
      isEdit: false,
      districts: [],
      groups: [],
      users: [],
      item: {
        district: null,
        listApproval: [
          {
            group_id: null,
            user_ids: [],
            users: [],
            loadingUsers: false
          }
        ]
      },
      loadingUsers: false
    };
  },
  watch: {
    descending() {
      this.getData();
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    searchBrand() {
      this.isSearch = true;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.getData();
      }, 900);
    },
    async getData() {
      if (this.id) {
        await this.getDetail();
      }
      await this.getGroups();
    },
    getDetail() {
      this.loading = true;
      return this.$store
        .dispatch('sshcp/getDetailApprovalMapping', { id: this.id })
        .then(data => {
          this.loading = false;
          if (data.code === 200) {
            this.item = data.data.result;
            if (this.item.listApproval.length < 1) {
              this.item.listApproval = [
                {
                  group_id: null,
                  user_ids: [],
                  users: [],
                  loadingUsers: false
                }
              ];
            } else {
              this.item.listApproval = this.item.listApproval.map(item => {
                return {
                  ...item,
                  users: [],
                  loadingUsers: false
                };
              });
              for (let i = 0; i < this.item.listApproval.length; i++) {
                if (
                  this.item.listApproval[i].group_id &&
                  this.item.listApproval[i].users.length === 0
                ) {
                  this.getUsers(this.item.listApproval[i]);
                }
              }
            }
          } else {
            this.loading = false;
            Swal.fire('Failed!', data.message.text_en, 'error');
          }
        })
        .catch(err => {
          this.loading = false;
          Swal.fire('Failed!', err.message.text_en, 'error');
        });
    },
    getGroups() {
      this.loading = true;
      return this.$store
        .dispatch('sshcp/getGroup', {
          paginate: false
        })
        .then(data => {
          this.loading = false;
          if (data.code === 200) {
            this.groups = data.data;
          } else {
            Swal.fire('Failed!', data.message.text_en, 'error');
          }
        })
        .catch(err => {
          this.loading = false;
          Swal.fire('Failed!', err.message.text_en, 'error');
        });
    },
    getUsers(item, changed) {
      item.loadingUsers = true;
      item.user_ids = changed ? [] : item.user_ids;
      return this.$store
        .dispatch('sshcp/getUserByGroup', {
          paginate: false,
          group_id: item.group_id
        })
        .then(data => {
          item.loadingUsers = false;
          if (data.code === 200) {
            item.users = data.data.users;
          } else {
            Swal.fire('Failed!', data.message.text_en, 'error');
          }
        })
        .catch(err => {
          item.loadingUsers = false;
          Swal.fire('Failed!', err.message.text_en, 'error');
        });
    },
    addApprover(index) {
      this.item.listApproval.splice(index + 1, 0, {
        group_id: null,
        user_ids: [],
        users: [],
        loadingUsers: false
      });
    },
    removeApprover(index) {
      Swal.fire({
        title: '',
        text: 'Are you sure want to delete this approver?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No'
      }).then(result => {
        if (result.value) {
          this.item.listApproval.splice(index, 1);
        }
      });
    },
    async save() {
      const validated = await this.$refs.obs.validate();
      if (validated) {
        Swal.fire({
          title: '',
          text: 'Are you sure want to save this data?',
          type: 'question',
          showCancelButton: true,
          confirmButtonText: 'Yes',
          cancelButtonText: 'No'
        }).then(result => {
          if (result.value) {
            this.progressDialogLoading = true;
            let body = {
              district_mapping_id: this.item.district.id,
              approvers: this.item.listApproval.map((item, index) => {
                return {
                  group_id: item.group_id,
                  approval_level: index + 1,
                  user_ids: item.user_ids
                };
              })
            };
            return this.$store
              .dispatch('sshcp/createApprovalMapping', body)
              .then(data => {
                this.progressDialogLoading = false;
                if (data.code === 200) {
                  Swal.fire('Success!', data.message.text_en, 'success');
                  this.$router.push({
                    name: 'sshcp_approval_mapping'
                  });
                } else {
                  this.progressDialogLoading = false;
                  Swal.fire('Failed!', data.message.text_en, 'error');
                }
              })
              .catch(err => {
                this.progressDialogLoading = false;
                Swal.fire('Failed!', err.message.text_en, 'error');
              });
          }
        });
      }
    }
  }
};
</script>
